export default "__VITE_ASSET__DdY1lvfD__"